/**
 * Marketplace Category model.
 */
export default {
  fields: {
    id: 0,
    marketplace: {
      id: 0,
      name: '',
      title: '',
    },
    marketplaceId: 0,
    marketplaceUid: '',
    name: '',
    nameFull: '',
    parentId: 0,
    templates: {},
    required: false,
    isListingAllowed: false,
  },
  getDefaults() {
    return JSON.parse(JSON.stringify(this.fields));
  },
  /**
   * Returns completed fields from a response.
   * @param response
   */
  fromApiResponse(response) {
    return {
      id: response.id,
      marketplace: response.marketplace !== 'undefined' ? response.marketplace : {},
      marketplaceId: response.market_id,
      marketplaceUid: response.marketplace_uid,
      name: response.name,
      nameFull: response.name_full,
      parentId: response.parent_id,
      templates: response.templates === null
      || Array.isArray(response.templates) ? {} : response.templates,
      required: typeof response.required === 'undefined' ? false : response.required,
      isListingAllowed: response.is_listing_allowed,
    };
  },
  /**
   * Return an object for sending to a API
   * @param data
   */
  toApiRequest(data) {
    return {
      market_id: data.marketplace.id,
      parent_id: data.parentId,
      name: data.name,
      name_full: data.minMargin,
      marketplace_uid: data.marketplaceUid,
      templates: data.templates,
      required: data.required,
      is_listing_allowed: data.isListingAllowed,
    };
  },
};
